export default __webpack_public_path__ + "static/media/searchDude.7109ae8a.svg";